import React from "react";

const Dashboard = () => {
    return <h1>Welcome to HasibX Dashboard</h1>;
};

export default Dashboard;
